/**
 * Nederlandse vertaalwoordenboek voor de Integration Portal.
 * Alle teksten in de applicatie worden hier beheerd.
 */
export const nl = {
  // Navigatie
  nav: {
    home: 'Home',
    licenties: 'AI Licenties',
    instellingen: 'Instellingen',
  },

  // Algemeen
  common: {
    afmelden: 'Afmelden',
    terugNaarHome: 'Ga terug naar de homepagina',
    copyright: '© 2026 Dura Vermeer',
    documentatie: 'Documentatie',
  },

  // Home pagina (welkomstpagina)
  home: {
    bannerTitle: 'Welkom bij de',
    bannerTitleHighlight: 'Integration Portal',
    bannerSubtitle: 'Jouw centrale plek voor Dura Vermeer integraties en beheer',
  },

  // Licenties pagina
  licenties: {
    pageTitle: 'Licentieoverzicht - AI Licenties',
    overviewPlaceholder: 'Licentieoverzicht wordt hier getoond',
    formsPlaceholder: 'Formulieren worden hier getoond',
    comingSoon: 'In ontwikkeling — inhoud volgt binnenkort.',
    loading: 'Gegevens laden…',
    loadError: 'Kon licentiegegevens niet laden.',
    managerTitle: 'Leidinggevende (Afas)',
    noManager: 'Niet opgehaald — controleer employees API configuratie.',
    preconditionsTitle: 'Voorwaarden (training)',
    requestsTitle: 'Jouw aanvragen',
    rulesTitle: 'Regels',
    activeLicensesTitle: 'Actieve licentie',
    newRequestsTitle: 'Nieuwe licentieaanvragen',
    noActiveLicenses: 'Geen actieve licentie.',
    noNewRequests: 'Geen openstaande of nieuwe aanvragen.',
    canRequest: 'Je kunt een aanvraag indienen.',
    cannotRequest: 'Je kunt nu geen aanvraag indienen.',
    blocked: 'Geblokkeerd',
    requestFormTitle: 'Nieuwe aanvraag',
    productLabel: 'Product',
    reasonLabel: 'Toelichting (verplicht bij tweede licentie)',
    reasonHint: 'Leg uit waarom je een extra productlicentie nodig hebt.',
    submit: 'Aanvraag indienen',
    submitting: 'Bezig…',
    submitError: 'Aanvraag mislukt',
    noProducts: 'Geen producten geconfigureerd.',
    preconditionMet: 'Voldaan',
    preconditionNotMet: 'Niet mogelijk',
    hintCanRequest: 'Klik op aanvragen om de licentie aan te vragen.',
    hintPreconditionsNotMet: 'Je kunt deze licentie niet aanvragen omdat je niet aan de trainingsvoorwaarden voldoet.',
    hintNeedApprovedFirst: 'Je hebt een eerder goedgekeurde licentie nodig om een 2e aanvraag te doen.',
    switchPolicyNote: 'Beleid wisselen',
    owned: 'Licentie verstrekt',
    requested: 'Licentie aangevraagd',
    requestButton: 'Licentie aanvragen',
    approvalsTitle: 'Goedkeuren of weigeren',
    noApprovals: 'Er zijn geen aanvragen om goed te keuren.',
    approve: 'Goedkeuren',
    deny: 'Weigeren',
    decisionSuccess: 'De beslissing is verwerkt.',
    decisionError: 'Fout bij verwerken van de beslissing.',
    adminTitle: 'Licentie administratie',
    adminLoading: 'Licenties laden...',
    adminNoLicenses: 'Geen goedgekeurde licenties gevonden.',
    adminColEmployee: 'Medewerker',
    adminColEmail: 'E-mail',
    adminColLicense: 'Licentie',
    adminColStatus: 'Status',
    adminColManager: 'Manager',
    adminColRequestedAt: 'Aangevraagd op',
    adminColRevokedBy: 'Ingetrokken door',
    adminColRevokedAt: 'Ingetrokken op',
    adminColActions: 'Acties',
    adminRevoke: 'Intrekken',
    adminRevokeSuccess: 'Licentie is ingetrokken.',
    adminRevokeError: 'Fout bij intrekken van de licentie.',
    adminStatusApproved: 'Goedgekeurd',
    adminStatusCompleted: 'Actief',
    adminStatusRevoked: 'Ingetrokken',
    adminFilterLabel: 'Zoeken',
    adminFilterPlaceholder: 'Licentie, naam of e-mail',
  },

  // 404 pagina
  notFound: {
    message: 'De pagina waar je naar op zoek was kon niet worden gevonden',
  },

  // Geen toegang pagina
  geenToegang: {
    title: 'Geen toegang',
    message: 'Dit portaal is alleen toegankelijk voor Dura Vermeer medewerkers.',
    afmelden: 'Afmelden',
  },

  // Uitgelogd pagina
  uitgelogd: {
    title: 'Je bent uitgelogd',
    message: 'Tot ziens! Klik hieronder om opnieuw in te loggen.',
    inloggen: 'Inloggen',
  },
} as const;
